import LocalisationMisService from "../services/LocalisationMisService";

// utilitaires pour formater les valeurs
export const formatDepart = (destination) => {
  if (isEmpty(destination.region_depart) && isEmpty(destination.commune_depart) && isEmpty(destination.district_depart))
     {
    return destination.type === "DR" ? destination.depart?.toUpperCase() ?? "" : `${destination.direction_location.toUpperCase()} (${destination.direction_code})` ?? "" ?? ""; 
  } else {
    return `${destination.region_depart ?? ""} / ${destination.district_depart ?? ""} / ${destination.commune_depart ?? ""}`;
  }

};

export const formatArrivee = (destination) => {
 if ( isEmpty(destination.region_arrivee) && isEmpty(destination.commune_arrivee) && isEmpty(destination.district_arrivee))
  {

    return destination.type === "DR" ? destination.arrivee?.toUpperCase() ?? "" : 
    (destination.activite === "mis") ? `${destination.region_depart ?? ""} / ${destination.district_depart ?? ""} / ${destination.commune_depart ?? ""}` :
    `${destination.direction_location.toUpperCase()} (${destination.direction_code})` ?? "";
  } else {
    return `${destination.region_arrivee ?? ""} / ${destination.district_arrivee ?? ""} / ${destination.commune_arrivee ?? ""}`;
  }
};

export  const isEmpty = (val) => val === null || val === undefined || val === "";

  /**  Calculate number of nights between two dates for mission timesheet
   * @param {string} DateString - Date in 'YYYY-MM-DD' format date of the post
   * @param {string} startDateString - Start date in 'YYYY-MM-DD' format
   * @param {string} endDateString - End date in 'YYYY-MM-DD' format
   * @returns {number} Number of nights between the two dates
   */
  

export const fetchAllRegions = async () => {
    try {
        const result = LocalisationMisService.getAllRegions();
        return result;
    } catch (error) {
        if (error.response) {
             return error.response.data;
        }
    }
};

export const fetchDistrictsByRegion = async (region) => {
    try {
        const result = LocalisationMisService.getDistrictsByRegion(region);
        return result;
    } catch (error) {
        if (error.response) {
             return error.response.data;
        }
    }
};

export const fetchCommunesByDistrict = async (district) => {
    try {
      const result = LocalisationMisService.getCommunesByDistrict(district);
      return result;
    } catch (error) {
      if (error.response) {
           return error.response.data;
      }
    }
};

export const fetchFokontanyByCommune = async (commune) => {
    try {
      const result = LocalisationMisService.getFokontantByCommune(commune);
      return result;
    } catch (error) {
      if (error.response) {
           return error.response.data;
      }
    }
};